var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vt-grid',{staticClass:"ps-grid",attrs:{"grid-options":_vm.gridOptions,"column-defs":_vm.columnDefs,"row-data":_vm.rowData,"component-code":"uicomponent.registry.subrequestgrid"}})}
var staticRenderFns = []

export { render, staticRenderFns }